import { PhoneIcon, EmailIcon } from './Icons';
import { GlassCard } from './GlassCard';
import { T } from '../lib/design-tokens';
import type { EvidenceRecord } from '../types';

interface EvidenceListProps {
  evidence: EvidenceRecord[];
  onPlayRecording: (evidenceId: string) => void;
  onViewTranscript?: (evidence: EvidenceRecord) => void;
}

function formatDuration(seconds: number | null) {
  if (!seconds) return '';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}m ${s.toString().padStart(2, '0')}s`;
}

export function EvidenceList({ evidence, onPlayRecording, onViewTranscript }: EvidenceListProps) {
  if (!evidence.length) return null;

  return (
    <div className="flex flex-col gap-1.5">
      {evidence.map((ev) => {
        const label =
          ev.type === 'call'
            ? `Call recording${ev.repName ? ` — ${ev.repName}` : ''}`
            : `Email${ev.emailSubject ? ` — ${ev.emailSubject}` : ''}`;
        const meta =
          ev.type === 'call' && ev.callDuration
            ? formatDuration(ev.callDuration)
            : ev.transcript
              ? `${(ev.transcript.length / 1024).toFixed(1)} KB`
              : '';

        return (
          <GlassCard
            key={ev.id}
            hover
            onClick={() => {
              if (ev.type === 'call' && ev.recordingUrl) {
                onPlayRecording(ev.id);
              } else if (ev.transcript && onViewTranscript) {
                onViewTranscript(ev);
              }
            }}
            style={{
              padding: '14px 18px',
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              cursor: 'pointer',
            }}
          >
            <div
              className="shrink-0 flex items-center justify-center rounded-lg"
              style={{
                width: 34,
                height: 34,
                background: ev.type === 'call' ? T.goldGlow : T.greenDim,
                color: ev.type === 'call' ? T.gold : T.green,
              }}
            >
              {ev.type === 'call' ? <PhoneIcon size={16} /> : <EmailIcon size={16} />}
            </div>
            <span
              style={{
                fontFamily: T.sans,
                fontSize: 13,
                color: T.cream,
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {label}
            </span>
            <span style={{ fontFamily: T.mono, fontSize: 10, color: T.cream12 }}>{meta}</span>
          </GlassCard>
        );
      })}
    </div>
  );
}
